export default "__VITE_ASSET__DGYmZv5A__"